import { getImageObject, getRefName } from '../utils';

export function FileLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    preview: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.preview),
      colors
    )
  };
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
}
